import ProductBase from './productBase.js';

export default class RDS extends ProductBase {
  buyUrl = 'https://rds-buy.aliyun.com/rdsBuy';

  match(code) {
    return code === 'rds';
  }

  setPeroid(config, number,type) {
    config.timeType = type;
    config.usedTime = number;
  }

  getDefaultConfig() {
    return {
      'commodityCode': 'rds',
      'resource': 'buy',
      'autoPay': 'false',
      'orderType': 'buy',
      'dBInstanceNetType': 'Intranet',
      'instanceUsedType': 0,
      'couponNo': 'no',
      'nodeType': 'HighAvailability', //系列
      'instanceNetworkType': 'VPC',//网络类型，专有网络-VPC，经典网络-Classic
      'vpcId': '', 
      'vSwitchId': '', //虚拟交换机
      'quantity': 1 //购买台数
    };
  }

  getConfig(commodityValue) {
    let config = this.getDefaultConfig();
    commodityValue = commodityValue || this.commodityValue;
    
    Object.assign(config, {
      dBInstanceStorage: commodityValue.rds_storage,
      engine: commodityValue.rds_dbtype,
      engineVersion: commodityValue.rds_dbversion,
      nodeType: commodityValue.rds_nodetype,
      instanceNetworkType: commodityValue.rds_web_type,
      dBInstanceClass: commodityValue.rds_class,
      regionId: commodityValue.rds_region,
      quantity: this.formatQuantity(commodityValue)
    });

    return config;
  }

  getBuyConfig() {
    let params = Object.assign({}, this.commodityValue);
    delete params.price;

    return {
      initData: params
    };
  }
} 


// WEBPACK FOOTER //
// ./lib/services/product/rds.js